import {
    Content,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge,
    CarouselContainer,
} from './styles';
import { appStoreURL } from '../../constants/urls';
import Carousel from '../Carousel';

const Home = () => {
    return (
        <Content>
            <TextContainer>
                <Title>SmarterToDo</Title>
                <SubTitle>Your smartest to-do list.</SubTitle>
                <Description>SmarterToDo is an AI-powered task manager for iPhone. Organize with hierarchical tags, get intelligent suggestions, and stay on top of your day with smart filters and voice input. No clutter, no subscription.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" /></a>
            </TextContainer>
            <CarouselContainer>
                <Carousel />
            </CarouselContainer>
        </Content>
    );
}

export default Home;
